import React, { Suspense, Fragment, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Authenticated from "./Guard/Authenticated";
import Layout from "./Layout";
export function RenderRout() {
  return (
    <>
      <Router>
        <Suspense fallback={"....."}>
          <Routes>
            {routes?.map((route, i) => {
              const Guard = route?.guard || Fragment;
              const Auth = route?.auth || Fragment;
              const Layout = route?.layout || Fragment;
              const Component = route?.element;
              return (
                <Route
                  key={i}
                  path={route.path}
                  exact={route.exact}
                  element={
                    <Guard>
                      <Auth>
                        <Layout>
                          <Component />
                        </Layout>
                      </Auth>
                    </Guard>
                  }
                />
              );
            })}
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

const routes = [

   {
    layout: Layout,
    exact: true,
    path: "/",
    element: lazy(() => import("./Components/Home")),
  },
   {
    layout: Layout,
    exact: true,
    path: "/line-callback",
    element: lazy(() => import("./Page/LineCallback")),
  },
  
   {
    layout: Layout,
    exact: true,
    path: "/menu/:id?",
    element: lazy(() => import("./Page/Lisitng")),
  },
  
 {
    layout: Layout,
    exact: true,
    path: "/menu-details/:id",
    element: lazy(() => import("./Page/ListingDetails")),
  },
 {
    layout: Layout,
    exact: true,
    path: "/view-cart",
    element: lazy(() => import("./Page/ViewCart")),
  },
{
    layout: Layout,
    exact: true,
    path: "/checkout",
    element: lazy(() => import("./Page/Checkout")),
  },
  {
    layout: Layout,
    exact: true,
    path: "/restaurant",
    element: lazy(() => import("./Page/Restaurant")),
  },
   {
    layout: Layout,
    exact: true,
    path: "/restaurant-detail/:id",
    element: lazy(() => import("./Page/RestaurantDetail")),
  },
  {
    layout: Layout,
    exact: true,
    path: "/food-truck",
    element: lazy(() => import("./Page/FoodTruck")),
  },
   {
    layout: Layout,
    exact: true,
    path: "/food-truck-detail/:id",
    element: lazy(() => import("./Page/FoodTruckDetail")),
  },

   {
    layout: Layout,
    exact: true,
    path: "/content/:id",
    element: lazy(() => import("./Components/Content")),
  },

     {
    layout: Layout,
    exact: true,
    path: "/contact",
    element: lazy(() => import("./Page/Contact")),
  },
  {
    guard:Authenticated,
    layout: Layout,
    exact: true,
    path: "/dashboard",
    element: lazy(() => import("./Page/Dashboard")),
  },

    {
    guard:Authenticated,
    layout: Layout,
    exact: true,
    path: "/payment-cancel",
    element: lazy(() => import("./Page/PaymentFailed")),
  },

    {
    guard:Authenticated,
    layout: Layout,
    exact: true,
    path: "/payment-success",
    element: lazy(() => import("./Page/PaymentSuccessful")),
  },
 {
  
    layout: Layout,
    exact: true,
    path: "/table-payment-success",
    element: lazy(() => import("./Page/PaymentSuccessfulres")),
  },
 {
  
    layout: Layout,
    exact: true,
    path: "/about",
    element: lazy(() => import("./Page/About")),
  },
 {
  
    layout: Layout,
    exact: true,
    path: "/delivery",
    element: lazy(() => import("./Page/Delivery")),
  },
 {
    layout: Layout,
    exact: true,
    path: "/catering",
    element: lazy(() => import("./Page/Catering")),
  },
  
];

